// api/auth.js
import keycloak from '@/api/keycloak'
import { clearAnalyticsUser, setAnalyticsUser } from '@/api/firebaseAnalytics'

export async function requireAuth(action = 'perform this action') {
    try {
        await keycloak.updateToken(5)
        localStorage.setItem('auth_token', keycloak.token)

        const userId = keycloak.tokenParsed?.sub || localStorage.getItem('userId') || ''
        const email = keycloak.tokenParsed?.email
            || keycloak.idTokenParsed?.email
            || localStorage.getItem('email')
            || ''
        const username = keycloak.tokenParsed?.preferred_username
            || keycloak.idTokenParsed?.preferred_username
            || localStorage.getItem('username')
            || ''

        localStorage.setItem('userId', userId)
        localStorage.setItem('email', email)
        localStorage.setItem('username', username)

        setAnalyticsUser({ userId, username, email })
        return true
    } catch (err) {
        console.log(`Auth required to ${action}; redirecting to login…`, err)
        keycloak.login()
        return false
    }
}

export function checkAuthentication() {
    const authToken = localStorage.getItem('auth_token')
    const userId = localStorage.getItem('userId')

    if (!authToken || authToken === '' || !userId || userId === '') {
        console.log('Authentication check failed: missing credentials')
        return {
            isAuthenticated: false,
            hasToken: !!authToken && authToken !== '',
            hasUserId: !!userId && userId !== '',
            userId: null
        }
    }

    console.log('Authentication check passed')
    return {
        isAuthenticated: true,
        hasToken: true,
        hasUserId: true,
        userId: userId
    }
}

export function logout() {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('userId')
    localStorage.removeItem('username')
    localStorage.removeItem('email')
    clearAnalyticsUser()
    console.log('User logged out, credentials cleared')
    keycloak.logout({ redirectUri: window.location.origin + '/' })
}
